import { ComponentPropsWithoutRef, FC, HTMLProps } from 'react';
import LoadingButton from '@/components/functional/LoadingButton/LoadingButton.tsx';
import { cn } from '@/utils/classNames.ts';

type WhiteBgButtonProps = Omit<ComponentPropsWithoutRef<typeof LoadingButton>, 'variant'> & {
  type?: HTMLProps<HTMLButtonElement>['type'];
};

const WhiteBgButton: FC<WhiteBgButtonProps> = ({ className, ...rest }) => {
  return (
    <LoadingButton
      {...rest}
      variant="outline"
      className={cn('[&:not(:hover)]:bg-white px-10 min-h-[42px] h-[42px]', className)}
    />
  );
};

export default WhiteBgButton;
